import React from "react";

const Bin = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      width="256"
      height="256"
    >
      <path
        fill="#f6f6f6"
        d="M18 5h-4a1 1 0 0 1 0-2h4a1 1 0 0 1 0 2Z"
        className="coloradcdd5 svgShape"
      ></path>
      <path
        fill="#fff"
        d="M26 6H6a1 1 0 0 0 0 2h1v18a3.003 3.003 0 0 0 3 3h12a3.003 3.003 0 0 0 3-3V8h1a1 1 0 0 0 0-2Zm-3 20a1 1 0 0 1-1 1H10a1 1 0 0 1-1-1V8h14Z"
        className="color75a6b4 svgShape"
      ></path>
      <path
        fill="#FFF"
        d="M13 24a1 1 0 0 1-1-1V12a1 1 0 0 1 2 0v11a1 1 0 0 1-1 1zm6 0a1 1 0 0 1-1-1V12a1 1 0 0 1 2 0v11a1 1 0 0 1-1 1z"
        className="coloradcdd5 svgShape"
      ></path>
    </svg>
  );
};

export default Bin;
